import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const BackDeleteIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M23.7778 3.77783H7.4468L0.147339 12.0001L7.4468 20.2223H23.7778V3.77783ZM1.94485 12.0001L8.01419 5.16345H22.4676V18.8367H8.01419L1.94485 12.0001ZM15.1111 11.0591L12.6267 8.57468L11.6858 9.51562L14.1702 12.0001L11.6858 14.4845L12.6267 15.4254L15.1111 12.941L17.5956 15.4254L18.5365 14.4845L16.0521 12.0001L18.5365 9.51562L17.5956 8.57468L15.1111 11.0591Z"
          fill="#5C5C5C"
        />
      </svg>
    )
  },
)
